import { createSlice } from "@reduxjs/toolkit";
import { getStorageTrackingApi } from "services/storageTracking/storageTracking.thunks";

const name = "storageTracking";
const initialState = {
  storageTrackingData: null,
};

const extraReducers = (builder) => {
  const { pending, fulfilled, rejected } = getStorageTrackingApi;
  builder
    .addCase(pending, (state) => {
      state.storageTrackingData = { loading: true };
    })
    .addCase(fulfilled, (state, action) => {
      state.storageTrackingData = action.payload.Data;
    })
    .addCase(rejected, (state, action) => {
      state.storageTrackingData = { error: action.error };
    });
};

const slice = createSlice({ name, initialState, extraReducers });

export const storageTrackingReducer = slice.reducer;
